import React from 'react';

const Footer = () => {
  const handleSectionLinkClick = (event, sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      event.preventDefault();
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="cvx-footer">
      <div className="cvx-footer-inner container mx-auto px-5 sm:px-8">
        <div className="cvx-footer-main">
          <div className="cvx-footer-brand-group">
            <p className="cvx-footer-brand">
              CloudVetX
            </p>
            <p className="cvx-footer-description">
              Veterinary practice software for appointments, patient records and clinic operations. Explore CloudVetX with our team.
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
                <Instagram size={20} />
              </a>
            </div> */}
          </div>

          <nav className="cvx-footer-nav" aria-label="Footer navigation">
            <p className="cvx-footer-heading">Quick Links</p>
            <ul className="cvx-footer-links">
              <li>
                <a
                  href="/#features"
                  onClick={(event) => handleSectionLinkClick(event, 'features')}
                  className="cvx-footer-link"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="/#about"
                  onClick={(event) => handleSectionLinkClick(event, 'about')}
                  className="cvx-footer-link"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/#pilot"
                  onClick={(event) => handleSectionLinkClick(event, 'pilot')}
                  className="cvx-footer-link"
                >
                  Founders Pilot
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  onClick={(event) => handleSectionLinkClick(event, 'contact')}
                  className="cvx-footer-link"
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          {/* <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Training</a></li>
              <li><a href="#" className="hover:text-white transition-colors">System Status</a></li>
            </ul>
          </div> */}
        </div>

        <div className="cvx-footer-bottom">
          <p className="cvx-footer-copyright">
            © {currentYear} CloudVetX. All rights reserved.
          </p>
          <nav className="cvx-footer-legal" aria-label="Legal">
            <a href="/privacy-policy" className="cvx-footer-legal-link">Privacy Policy</a>
            <a href="/terms" className="cvx-footer-legal-link">Terms of Service</a>
            <a href="/data-processing" className="cvx-footer-legal-link">Data Processing Agreement (DPA)</a>
            {/* <a href="#" className="cvx-footer-legal-link">HIPAA Compliance</a> */}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
